import Vue from 'vue'
import Login from '@/components/Login'
import Index from '@/components/Index'
import Main from '@/components/Main'


/**
 * routes==默认路由节点
 */
export const loginRouter = {
    path: '/login',
    name: 'Login', //登录
    component: Login,
    title: "登陆",
    hidden: true
}
/**
 * routes==默认路由节点
 */
export const appRouter = [{
        path: '/',
        name: 'MainIndex',
        redirect: '/index',
        component: Main,
        title: "首页",
        children: [{
            path: 'index',
            component: Index,
            name: "Index",
            title: "工作台"
        }]
    },
    {
        path: '/',
        hidden: true,
        title: "会员管理",
        name: "MerchantManage",
        component: Main,
        children: [{
            title: "会员管理",
            path: '/merchant/list',
            component: resolve => { require(['@/components/Merchant/MerchantList.vue'], resolve) },
            name: "MerchantList",
        }, {
            title: '推广二维码',
            name: "WarehouseQrcode",
            path: '/loginlog/list',
            component: resolve => { require(['@/components/User/WarehouseQrcode.vue'], resolve) }
        }]
    },
    {
        path: '/',
        hidden: true,
        component: Main,
        title: "仓储管理",
        name: "StorageManage",
        children: [{
                path: '/shelves/list',
                title: "库位管理",
                component: resolve => { require(['@/components/ShelvesLocation/ShelvesLocationList.vue'], resolve) },
                name: "ShelvesLocationList",
            },
            {
                path: '/product/list',
                title: "库存商品",
                component: resolve => { require(['@/components/ShelvesLocation/StorageProductList.vue'], resolve) },
                name: "StorageProductList",
            },
            {
                path: '/bill/list',
                title: "入库单管理",
                component: resolve => { require(['@/components/StorageBill/StorageBillList.vue'], resolve) },
                name: "StorageBillList",
            },
            {
                path: '/bill/sign',
                title: "入库单签收",
                component: resolve => { require(['@/components/Outgo/BillSign.vue'], resolve) },
                name: "BillSign",
            }
        ]
    },
    {
        path: '/warehouse',
        title: "基础设置",
        hidden: true,
        component: Main,
        name: "BaseSet",
        children: [{
                title: '个人信息',
                path: 'info',
                component: resolve => { require(['@/components/User/Info.vue'], resolve) },
                name: "UserInfo",
            }, {
                title: '修改密码',
                name: "Password",
                path: 'pwd',
                component: resolve => { require(['@/components/User/Password.vue'], resolve) }
            }, {
                title: '微信绑定',
                name: "Weixin",
                path: 'weixin',
                component: resolve => { require(['@/components/User/Weixin.vue'], resolve) }
            },

            {
                title: '员工管理',
                name: "WarehouseUserList",
                path: 'warehoseuser/list',
                component: resolve => { require(['@/components/WarehouseUser/WarehouseUserList.vue'], resolve) }
            }
        ]

    },
    {
        path: '/warehouse',
        title: "仓库管理",
        hidden: true,
        component: Main,
        name: "Warehouse",
        children: [{
                title: '仓库列表',
                name: "WarehouseList",
                path: 'warehose/list',
                component: resolve => { require(['@/components/Warehouse/WarehouseList.vue'], resolve) }
            }, {
                title: '新增仓库',
                name: "WarehouseAdd",
                path: 'warehose/add',
                component: resolve => { require(['@/components/Warehouse/WarehouseAdd.vue'], resolve) }
            }, {
                title: '修改仓库',
                name: "WarehouseEdit",
                path: 'warehouse/edit/:warehouseId',
                component: resolve => { require(['@/components/Warehouse/WarehouseEdit.vue'], resolve) }
            },
            {
                title: '员工管理',
                name: "WarehouseUserList",
                path: 'warehoseuser/list',
                component: resolve => { require(['@/components/WarehouseUser/WarehouseUserList.vue'], resolve) }
            }
        ]

    },

    {
        path: '/',
        title: "财务管理", //登录
        hidden: true,
        name: "FinanceManage",
        component: Main,
        children: [{
            title: '资金流水',
            path: '/moneylog/list',
            component: resolve => { require(['@/components/Finance/MoneyChangeLogList.vue'], resolve) },
            name: "MoneyLogList",
        }, {
            title: '提现记录',
            path: '/deposit/list',
            component: resolve => { require(['@/components/Finance/DepositList.vue'], resolve) },
            name: "DepositList",
        }, {
            title: '申请提现',
            path: '/deposit/create',
            component: resolve => { require(['@/components/Finance/DepositAdd.vue'], resolve) },
            name: "DepositAdd",
        }]
    }, {

        path: '/',
        title: "数据报表", //登录
        hidden: true,
        name: "AllDataReport",
        component: Main,
        children: [{
            title: '货代统计',
            path: '/data/waybill/data',
            component: resolve => { require(['@/components/Data/WaybillDataReport.vue'], resolve) },
            name: "WaybillDataReport",
        },{
            title: '业务统计',
            path: '/data/waybill/user/data',
            component: resolve => { require(['@/components/Data/WaybillUserReport.vue'], resolve) },
            name: "WaybillUserReport",
        }]
    },{

        path: '/',
        title: "集运管理", //登录
        hidden: true,
        name: "集运管理",
        component: Main,
        children: [{
            title: '集运记录',
            path: '/gather/list',
            component: resolve => { require(['@/components/GatherRecord/GatherRecordList.vue'], resolve) },
            name: "GatherRecordList",
        },{
            title: '集运流水',
            path: '/gather/money',
            component: resolve => { require(['@/components/GatherRecord/GatherMoneyLog.vue'], resolve) },
            name: "GatherMoneyLog",
        },{
            title: '集运模板',
            path: '/gather/freight/tpl',
            component: resolve => { require(['@/components/FreightTpl/FreightTplList.vue'], resolve) },
            name: "FreightTplList",
        }]
    },
    {
        path: '/',
        title: "货代管理", //登录
        hidden: true,
        name: "WaybillManage",
        component: Main,
        children: [{
            title: '待签收订单',
            path: '/waybill/type/list',
            component: resolve => { require(['@/components/Waybill/WaybillTypeList.vue'], resolve) },
            name: "WaybillTypeList",
        }, {
            title: '待签收订单',
            path: '/waybill/tosign/list',
            component: resolve => { require(['@/components/Waybill/WaybillToSignList.vue'], resolve) },
            name: "WaybillToSignList",
        }, {
            title: '待出库订单',
            path: '/waybill/tooutgoing/list',
            component: resolve => { require(['@/components/Waybill/WaybillToOutgoingList.vue'], resolve) },
            name: "WaybillToOutgoingList",
        }, {
            title: '已出库订单',
            path: '/waybill/outgoing/list',
            component: resolve => { require(['@/components/Waybill/WaybillOutgoingList.vue'], resolve) },
            name: "WaybillOutgoingList",
        }, {
            title: '已取消',
            path: '/waybill/cancel/list',
            component: resolve => { require(['@/components/Waybill/WaybillCancelList.vue'], resolve) },
            name: "WaybillCancelList",
        }, {
            title: '全部订单',
            path: '/waybill/list',
            component: resolve => { require(['@/components/Waybill/WaybillList.vue'], resolve) },
            name: "WaybillTodoList",
        }, {
            title: '异常订单',
            path: '/waybill/error/list',
            component: resolve => { require(['@/components/Waybill/WaybillErrorList.vue'], resolve) },
            name: "WaybillErrorList",
        },{
            title: "全部包裹",
            name: "WaybillExpressList",
            path: '/billexpress/list',
            component: resolve => { require(['@/components/WaybillExpress/WaybillExpressList.vue'], resolve) }
        }, {
            title: "仓库包裹",
            name: "WaybillExpressTypeList",
            path: '/billexpress/type/list',
            component: resolve => { require(['@/components/WaybillExpress/WaybillExpressTypeList.vue'], resolve) }
        }, {
            title: "已签收包裹",
            name: "WaybillExpressOkList",
            path: '/billexpress/oklist',
            component: resolve => { require(['@/components/WaybillExpress/WaybillExpressOkList.vue'], resolve) }
        }, {
            title: "待签收包裹",
            name: "WaybillExpressTodoList",
            path: '/billexpress/todolist',
            component: resolve => { require(['@/components/WaybillExpress/WaybillExpressTodoList.vue'], resolve) }
        }, {
            title: "订单包裹",
            name: "WaybillExpressShow",
            path: '/waybillexpress/show/:expressNo',
            component: resolve => { require(['@/components/WaybillExpress/WaybillExpressShow.vue'], resolve) }
        }, {
            title: "包裹签收",
            name: "WaybillExpressOutgo",
            path: '/outgo/waybillexpress',
            component: resolve => { require(['@/components/Outgo/WaybillExpressOutgo.vue'], resolve) }
        }, {
            title: "订单出库",
            name: "WaybillOutgo",
            path: '/outgo/waybill',
            component: resolve => { require(['@/components/Outgo/WaybillOutgo.vue'], resolve) }
        }, {
            title: "本土交接出库",
            name: "WaybillLocalOutgo",
            path: '/outgo/local/waybill',
            component: resolve => { require(['@/components/Outgo/WaybillLocalOutgo.vue'], resolve) }
        }, {
            title: "本土到货签收",
            name: "WaybillLocalSign",
            path: '/outgo/local/waybill/ougo',
            component: resolve => { require(['@/components/Outgo/WaybillLocalSign.vue'], resolve) }
        }, {
            title: "订单详情",
            name: "WaybillShow",
            path: '/waybill/show/:waybillOrder',
            component: resolve => { require(['@/components/Waybill/WaybillShow.vue'], resolve) }
        }, {
            title: "订单编辑",
            name: "WaybillEdit",
            path: '/waybill/edit/:waybillId',
            component: resolve => { require(['@/components/Waybill/WaybillEdit.vue'], resolve) }
        },{
            title: "快递退件",
            name: "ExpressBackList",
            path: '/expressback/list',
            component: resolve => { require(['@/components/ExpressBack/ExpressBackList.vue'], resolve) }
        }]
    }
]


export const routers = [
    loginRouter,
    ...appRouter
];